import 'application/src/scss/landingpage/logistics/logistics.scss';

import {
  VisibilityWatcher
} from 'application/src/js/util.js';

window.addEventListener('DOMContentLoaded', _ => {
  new VisibilityWatcher({
    elements: [
      document.querySelector('section.advantages')
    ]
  });

  new Glide(document.querySelector('section.testimonials .glide'), {
    autoplay: 10000,
    bound: 0,
    gap: 0,
    perMove: 1,
    type: 'carousel'
  }).mount();

  import( /* webpackChunkName: "request-freight-charges" */ 'application/src/js/logistics/request-freight-charges.js')
    .then(({
      default: RequestFreightCharges
    }) => {
      new RequestFreightCharges({
        isModal: false
      });
    });
});